// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"160":"component---src-pages-arenas-arena-mangled-tsx","218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"160":"97ab9f29b98ef5f673d5","218":"f32e768aec0e4d387cfe","691":"dab9fceb9768a9b2926d"}[chunkId] + ".js";
};